import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  getRoot,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request, utils } from 'lib';
import { MysticModel } from 'models/user-model';

const initState = {};

const RankUserModel = types
  .model('RankUserModel', {
    uid: 0,
    pic: '',
    value: 0,
    nickname: '',
    mystic: types.optional(MysticModel, {}),
  })
  .views((self) => {
    return {
      get afterPic() {
        return self.mystic.open ? self.mystic.pic : self.pic;
      },
      get afterNickname() {
        return self.mystic.open ? self.mystic.nick_name : self.nickname;
      },
      get afterId() {
        return self.mystic.open ? self.mystic.id : self.uid;
      },
    };
  });
export const MultiPkInfoModel = types.model('MultiPkInfoModel', {
  room_id: 0,
  // 1-胜利 2-失败 3-平局 默认为0
  pk_result: 0,
  pk_value: 0,

  top_user: types.array(RankUserModel),
});

const ModeInfoModel = types
  .model('ModeInfoModel', {
    // 1-准备阶段 2-pk阶段 3-结算阶段
    stage: 0,
    stage_desc: '',
    // 当前阶段持续时间
    duration: 0,
    // 当前阶段剩余时间
    remain_time: 0,
    multi_pk_info: types.array(MultiPkInfoModel),
  })
  .views((self) => {
    return {
      get currentRoom() {
        const { roomId } = getRoot(self).room;
        return self.multi_pk_info.find((item) => {
          return item.room_id === roomId;
        });
      },
      get otherRoom() {
        const { roomId } = getRoot(self).room;
        return self.multi_pk_info.find((item) => {
          return item.room_id !== roomId;
        });
      },
      get currentRoomValue() {
        const { roomId } = getRoot(self).room;
        const pkInfo = self.multi_pk_info.find((item) => {
          return item.room_id === roomId;
        });
        return pkInfo ? pkInfo.pk_value : 0;
      },
      get otherRoomValue() {
        const { roomId } = getRoot(self).room;
        const pkInfo = self.multi_pk_info.find((item) => {
          return item.room_id !== roomId;
        });
        return pkInfo ? pkInfo.pk_value : 0;
      },
      get totalValue() {
        return self.multi_pk_info.reduce((total, item) => {
          return total + item.pk_value;
        }, 0);
      },
      get remainTimeText() {
        return utils.getTimerText(self.remain_time);
      },
      // get isDoublePk() {
      //   return self.multi_pk_info.length === 2;
      // },
      get isShowResult() {
        return self.stage === 3;
      },
      get isShowRank() {
        return self.stage === 2;
      },
    };
  })
  .actions((self) => {
    const decreasePunishContentCountDown = () => {
      if (self.punish_content_count_down > 0) {
        self.punish_content_count_down--;
      }
    };
    const decreaseRemainTime = () => {
      if (self.remain_time > 0) {
        self.remain_time--;
      }
    };
    const getRoomPkInfo = (roomId) => {
      return self.multi_pk_info.find((item) => {
        return item.room_id === roomId;
      });
    };
    const updateTopUser = (roomId, topUsers) => {
      const pkInfo = getRoomPkInfo(roomId);
      if (pkInfo) {
        pkInfo.top_user = topUsers;
      }
    };
    const updatePkValue = (roomId, value) => {
      const pkInfo = getRoomPkInfo(roomId);
      if (pkInfo) {
        pkInfo.pk_value = value;
      }
    };
    return {
      decreasePunishContentCountDown,
      decreaseRemainTime,
      getRoomPkInfo,
      updateTopUser,
      updatePkValue,
    };
  });

const MatchingModel = types.model('MatchingModel', {
  id: '',
  timestamp: 0,
});

const RacePkInfoModel = types
  .model('RacePkInfoModel', {
    // 连麦时长
    pk_duration: 0,

    matching: types.optional(MatchingModel, {}),

    mode_info: types.optional(ModeInfoModel, {}),
  })
  .views((self) => {
    return {
      get isPkMode() {
        return true;
      },
      get isShowPkBar() {
        return self.mode_info.stage === 2;
      },
      get isMatching() {
        return self.matching.id && !self.mode_info.stage;
      },
      get isInPk() {
        return self.mode_info.stage > 0;
      },
      get frozenTimeText() {
        return utils.getTimerText(self.frozen.remaining, { d: true });
      },
      get isInRacePk() {
        return this.isMatching || this.isInPk;
      },
    };
  });

const Model = types
  .model('RacePkModel', {
    info: types.optional(RacePkInfoModel, {}),
  })
  .actions((self) => {
    const updateInfo = (info) => {
      self.info = info;
    };

    return {
      updateInfo,
    };
  });

export default {
  initState,
  Model,
};
